import { render } from "./recuperar-senha.vue?vue&type=template&id=764a3adb"
import script from "./recuperar-senha.vue?vue&type=script&lang=js"
export * from "./recuperar-senha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__